import React from 'react';

export default function ScheduleHistory({ list }) {
	return <div>{JSON.stringify(list)}</div>;
}
